module.exports = __webpack_public_path__ + "img/not-found.93afec96.svg";